<!-- Modal para Vista de Detalle de Versión -->
<div class="version-detail-container" *ngIf="isVisible">
  <div class="detail-backdrop" (click)="close()"></div>
  
  <div class="detail-panel">
    <!-- Header -->
    <div class="detail-header">
      <div class="d-flex align-items-center justify-content-between">
        <div class="d-flex align-items-center">
          <!-- Botón de timeline oculto temporalmente -->
          <!-- <button type="button" class="btn btn-outline-secondary me-3" (click)="backToTimeline()">
            <i class="fas fa-arrow-left me-2"></i>
            Volver al Timeline
          </button> -->
          <div>
            <h4 class="mb-0 fw-bold text-primary">Configuración de Versión</h4>
            <small class="text-muted" *ngIf="versionDetail">
              Visualización completa de {{ versionDetail.code }}
            </small>
          </div>
        </div>
        <button type="button" class="btn-close btn-close-lg" (click)="close()" aria-label="Close"></button>
      </div>
      
      <div class="mt-3" *ngIf="versionDetail">
        <div class="row">
          <div class="col-md-8">
            <div class="d-flex align-items-center flex-wrap gap-3">
              <div class="detail-stat">
                <i class="fas fa-code-branch text-primary me-2"></i>
                <span class="fw-bold">{{ versionDetail.code }}</span>
              </div>
              <div class="detail-stat">
                <i class="fas fa-calendar text-info me-2"></i>
                <span class="fw-bold">{{ formatDate(versionDetail.date) }}</span>
              </div>
              <div class="detail-stat">
                <i class="fas fa-user text-warning me-2"></i>
                <span class="fw-bold">{{ versionDetail.user.name }}</span>
              </div>
            </div>
          </div>
          <div class="col-md-4 text-end">
            <span class="badge me-2" 
                  [ngClass]="{'bg-success bg-opacity-15 text-success': versionDetail.status, 'bg-danger bg-opacity-15 text-danger': !versionDetail.status}">
              <i class="fas fa-circle me-1"></i>
              {{ versionDetail.status ? 'Activo' : 'Inactivo' }}
            </span>
            <span class="badge bg-warning bg-opacity-15 text-warning" *ngIf="versionDetail.paused">
              <i class="fas fa-pause me-1"></i>
              Pausado
            </span>
          </div>
        </div>
      </div>
    </div>

    <!-- Loading State -->
    <div class="detail-content" *ngIf="loading">
      <div class="text-center py-5">
        <div class="spinner-border text-primary mb-3" role="status" style="width: 3rem; height: 3rem;">
          <span class="visually-hidden">Cargando...</span>
        </div>
        <h6 class="text-muted">Cargando configuración de versión...</h6>
        <p class="text-muted small">Por favor espere un momento</p>
      </div>
    </div>

    <!-- Error State -->
    <div class="detail-content" *ngIf="error && !loading">
      <div class="alert alert-danger border-danger" role="alert">
        <div class="d-flex align-items-start">
          <i class="fas fa-exclamation-triangle text-danger me-3 mt-1"></i>
          <div class="flex-grow-1">
            <h6 class="alert-heading mb-2">Error al cargar la configuración</h6>
            <p class="mb-2">{{ error }}</p>
            <button class="btn btn-outline-danger btn-sm" (click)="fetchVersionDetail()">
              <i class="fas fa-redo me-2"></i>
              Reintentar
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Content -->
    <div class="detail-content" *ngIf="versionDetail && !loading && !error">
      <div class="detail-wrapper">
        
        <!-- SECCIÓN 1: INFORMACIÓN BÁSICA -->
        <div class="card mt-3 border-primary">
          <div class="card-header bg-primary bg-opacity-10">
            <div class="d-flex align-items-center">
              <i class="fas fa-info-circle text-primary me-2"></i>
              <h5 class="mb-0 text-primary">Información Básica de la Penalidad</h5>
            </div>
            <small class="text-secondary mt-1 d-block">
              Configuración general de la penalidad aplicada a los clientes
            </small>
          </div>
          <div class="card-body">
            <!-- Estatus -->
            <div class="row pt-3">
              <div class="col-6">
                <div class="form-floating">
                  <input type="text" 
                         class="form-control readonly-input" 
                         [value]="versionDetail.status ? 'Activa' : 'Inactiva'"
                         readonly>
                  <label>
                    <i class="fas fa-toggle-on me-1"></i>
                    Estatus
                  </label>
                  <div class="form-text">
                    <i class="fas fa-lightbulb text-warning me-1"></i>
                    <strong>Activa:</strong> La penalidad estará disponible para aplicarse. 
                    <strong>Inactiva:</strong> La penalidad no se aplicará aunque tenga reglas configuradas.
                  </div>
                </div>
              </div>
            </div>

            <!-- Título y Código -->
            <div class="row pt-3">
              <div class="col-6">
                <div class="form-floating">
                  <input type="text" 
                         class="form-control readonly-input" 
                         [value]="versionDetail.name"
                         readonly>
                  <label>
                    <i class="fas fa-tag me-1"></i>
                    Título de la Penalidad
                  </label>
                  <div class="form-text">
                    <i class="fas fa-lightbulb text-warning me-1"></i>
                    Nombre descriptivo que identifica claramente el propósito de esta penalidad
                  </div>
                </div>
              </div>
              
              <div class="col-6">
                <div class="form-floating">
                  <input type="text" 
                         class="form-control readonly-input" 
                         [value]="versionDetail.code"
                         readonly>
                  <label>
                    <i class="fas fa-barcode me-1"></i>
                    Código de Penalidad
                  </label>
                  <div class="form-text">
                    <i class="fas fa-lightbulb text-warning me-1"></i>
                    Código único para identificar esta penalidad en el sistema
                  </div>
                </div>
              </div>
            </div>
          
            <!-- Descripción -->
            <div class="row pt-3">
              <div class="col-12">
                <div class="form-floating">
                  <textarea class="form-control readonly-input" 
                            [value]="versionDetail.description"
                            readonly
                            style="height: 100px;">
                  </textarea>
                  <label>
                    <i class="fas fa-align-left me-1"></i>
                    Descripción Detallada
                  </label>
                  <div class="form-text">
                    <i class="fas fa-lightbulb text-warning me-1"></i>
                    Explica claramente las circunstancias en las que se aplicará esta penalidad
                  </div>
                </div>
              </div>
            </div>
          
            <!-- Tipo de Aplicación -->
            <div class="row pt-3">
              <div class="form-group col-12">
                <div class="form-floating">
                  <input type="text" 
                         class="form-control readonly-input" 
                         [value]="versionDetail.fee?.application_type?.name"
                         readonly>
                  <label>
                    <i class="fas fa-cogs me-1"></i>
                    Tipo de Aplicación
                  </label>
                  <div class="form-text">
                    <i class="fas fa-lightbulb text-warning me-1"></i>
                    Define el contexto donde se aplicará la penalidad (cuenta, cuota, etc.)
                  </div>
                </div>
              </div>
            </div>
          
            <!-- Frecuencia de Aplicación -->
            <div class="form-group col-12 mt-4">
              <div class="alert alert-info border-info">
                <div class="d-flex align-items-start">
                  <i class="fas fa-clock text-info me-2 mt-1"></i>
                  <div>
                    <h6 class="alert-heading mb-1">Frecuencia de Aplicación</h6>
                    <small>Configuración de la frecuencia con la que se puede aplicar esta penalidad al mismo cliente</small>
                  </div>
                </div>
              </div>
            </div>
            
            <div class="row">
              <div class="col-4">
                <div class="form-floating">
                  <input type="text" 
                         class="form-control readonly-input" 
                         [value]="versionDetail.fee?.frequency?.name"
                         readonly>
                  <label>
                    <i class="fas fa-calendar-alt me-1"></i>
                    Frecuencia
                  </label>
                  <div class="form-text">
                    <i class="fas fa-lightbulb text-warning me-1"></i>
                    Define cada cuánto tiempo se puede aplicar la misma penalidad
                  </div>
                </div>
              </div>
              
              <div class="col-4">
                <div class="form-floating">
                  <input type="text" 
                         class="form-control readonly-input" 
                         [value]="versionDetail.fee?.unit_of_measure"
                         readonly>
                  <label>
                    <i class="fas fa-ruler me-1"></i>
                    Unidad de Medida
                  </label>
                  <div class="form-text">
                    <i class="fas fa-lightbulb text-warning me-1"></i>
                    Especifica la unidad para medir la frecuencia (días, meses, etc.)
                  </div>
                </div>
              </div>
              
              <div class="col-4">
                <div class="form-floating">
                  <input type="text" 
                         class="form-control readonly-input" 
                         [value]="versionDetail.fee?.limit"
                         readonly>
                  <label>
                    <i class="fas fa-hashtag me-1"></i>
                    Límite
                  </label>
                  <div class="form-text">
                    <i class="fas fa-lightbulb text-warning me-1"></i>
                    Cantidad de unidades para el límite de frecuencia
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- SECCIÓN 2: REGLAS DE APLICACIÓN -->
        <div class="card mt-3 border-success">
          <div class="card-header bg-success bg-opacity-10">
            <div class="d-flex align-items-center justify-content-between">
              <div class="d-flex align-items-center">
                <i class="fas fa-list-ul text-success me-2"></i>
                <h5 class="mb-0 text-success">Reglas de Aplicación</h5>
              </div>
              <button type="button" 
                      class="btn btn-outline-success btn-sm"
                      (click)="toggleRules()">
                <i class="fas" [ngClass]="showRules ? 'fa-eye-slash' : 'fa-eye'" class="me-2"></i>
                {{ showRules ? 'Ocultar Reglas' : 'Ver Reglas' }}
                <span class="badge bg-success ms-2" *ngIf="versionDetail?.fees?.length">
                  {{ versionDetail.fees.length }}
                </span>
              </button>
            </div>
            <small class="text-secondary mt-1 d-block">
              Condiciones específicas y tarifas configuradas para aplicar esta penalidad
            </small>
          </div>
          <div class="card-body">
            
            <!-- Resumen de reglas (siempre visible) -->
            <div class="row">
              <div class="col-12 mb-3">
                <div class="alert alert-success border-success" *ngIf="versionDetail?.fees && versionDetail.fees.length > 0">
                  <div class="d-flex align-items-center justify-content-between">
                    <div class="d-flex align-items-center">
                      <i class="fas fa-check-circle text-success me-2"></i>
                      <h6 class="mb-0">{{ versionDetail.fees.length }} Regla{{ versionDetail.fees.length !== 1 ? 's' : '' }} Configurada{{ versionDetail.fees.length !== 1 ? 's' : '' }}</h6>
                    </div>
                    <div class="d-flex gap-2">
                      <span class="badge bg-success" 
                            *ngFor="let fee of versionDetail.fees; let i = index">
                        {{ fee.code || ('C' + (i + 1).toString().padStart(3, '0')) }}
                      </span>
                    </div>
                  </div>
                </div>
                <div class="alert alert-secondary border-secondary" *ngIf="!versionDetail?.fees || versionDetail.fees.length === 0">
                  <div class="d-flex align-items-center">
                    <i class="fas fa-info-circle text-secondary me-2"></i>
                    <h6 class="mb-0">No hay reglas configuradas</h6>
                  </div>
                </div>
              </div>
            </div>
            
            <!-- Lista detallada de reglas (mostrar/ocultar) -->
            <div class="rules-detail-section" *ngIf="showRules && versionDetail?.fees && versionDetail.fees.length > 0">
              <div class="row">
                <div class="col-12">
                  <hr class="my-3">
                  <h6 class="text-success mb-3">
                    <i class="fas fa-cogs me-2"></i>
                    Configuración Detallada de Reglas
                  </h6>
                </div>
              </div>
              
              <!-- Cada fee en una fila completa -->
              <div class="row mb-4" *ngFor="let fee of versionDetail.fees; let i = index">
                <div class="col-12">
                  <div class="card border-success shadow-sm">
                    <div class="card-header bg-success bg-opacity-5">
                      <div class="d-flex justify-content-between align-items-center">
                        <div class="d-flex align-items-center">
                          <!-- Código enfatizado -->
                          <div class="fee-code-badge me-3">
                            <span class="badge bg-success fs-6 px-3 py-2">
                              <i class="fas fa-hashtag me-1"></i>
                              <strong>{{ fee.code || ('C' + (i + 1).toString().padStart(3, '0')) }}</strong>
                            </span>
                          </div>
                          <div>
                            <h6 class="mb-0 text-success fw-bold">
                              Regla {{ i + 1 }} - {{ fee.concept_deduction || 'Concepto de Deducción' }}
                            </h6>
                            <small class="text-muted">
                              Configuración de tarifa y condiciones de aplicación
                            </small>
                          </div>
                        </div>
                        <div class="d-flex align-items-center gap-2">
                          <span class="badge bg-success" *ngIf="isFeeActive(fee)">
                            <i class="fas fa-check-circle me-1"></i>Activa
                          </span>
                          <span class="badge bg-secondary" *ngIf="!isFeeActive(fee)">
                            <i class="fas fa-times-circle me-1"></i>Inactiva
                          </span>
                        </div>
                      </div>
                    </div>
                    
                    <div class="card-body">
                      <!-- Condición de aplicación - Ancho completo -->
                      <div class="row mb-3">
                        <div class="col-12">
                          <div class="condition-section">
                            <h6 class="text-warning mb-2">
                              <i class="fas fa-filter me-2"></i>
                              Condición de Aplicación
                            </h6>
                            
                            <div *ngIf="fee.attribute && fee.condition" class="alert alert-warning border-warning bg-warning bg-opacity-10">
                              <div class="condition-display">
                                <div class="d-flex align-items-center flex-wrap gap-2 mb-2">
                                  <span class="badge bg-info fs-6">{{ fee.attribute }}</span>
                                  <span class="badge bg-secondary fs-6">{{ fee.condition }}</span>
                                  <span class="badge bg-primary fs-6">{{ fee.value }}</span>
                                </div>
                                <small class="text-warning">
                                  <i class="fas fa-info-circle me-1"></i>
                                  Se aplica cuando {{ fee.attribute }} {{ fee.condition }} {{ fee.value }}
                                </small>
                              </div>
                            </div>

                            <div *ngIf="!fee.attribute || !fee.condition" class="alert alert-info border-info bg-info bg-opacity-10">
                              <div class="d-flex align-items-center">
                                <i class="fas fa-globe text-info me-2"></i>
                                <div>
                                  <strong>Aplicación General</strong>
                                  <br>
                                  <small>Esta regla se aplica sin condiciones específicas</small>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <!-- Configuración de tarifa - Ancho completo -->
                      <div class="row mb-3">
                        <div class="col-12">
                          <div class="tariff-section">
                            <h6 class="text-success mb-2">
                              <i class="fas fa-dollar-sign me-2"></i>
                              Configuración de Tarifa
                            </h6>
                            
                            <div class="alert alert-success border-success bg-success bg-opacity-10">
                              <div class="tariff-display">
                                <div class="mb-2">
                                  <span class="badge bg-success bg-opacity-25 text-success fs-6 me-2">
                                    <i class="fas fa-tag me-1"></i>
                                    {{ fee.commission_type }}
                                  </span>
                                </div>
                                
                                <div class="d-flex align-items-center flex-wrap gap-3">
                                  <div *ngIf="fee.fixed_amount" class="tariff-item">
                                    <i class="fas fa-coins text-success me-1"></i>
                                    <strong class="text-success">
                                      ${{ fee.fixed_amount | number:'1.2-2' }}
                                    </strong>
                                    <small class="text-muted ms-1">fijo</small>
                                  </div>
                                  
                                  <div *ngIf="fee.percentage" class="tariff-item">
                                    <i class="fas fa-percentage text-success me-1"></i>
                                    <strong class="text-success">
                                      {{ fee.percentage }}%
                                    </strong>
                                    <small class="text-muted ms-1">variable</small>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <!-- Configuraciones adicionales - Ancho completo -->
                      <div class="row" *ngIf="fee.applies_reactivation || fee.applies_update_recalc">
                        <div class="col-12">
                          <div class="additional-config">
                            <h6 class="text-info mb-2">
                              <i class="fas fa-cogs me-2"></i>
                              Aplicaciones Especiales
                            </h6>
                            <div class="d-flex gap-2">
                              <span *ngIf="fee.applies_reactivation" class="badge bg-info bg-opacity-15 text-info">
                                <i class="fas fa-redo me-1"></i>
                                Aplica en Reactivación
                              </span>
                              <span *ngIf="fee.applies_update_recalc" class="badge bg-warning bg-opacity-15 text-warning">
                                <i class="fas fa-calculator me-1"></i>
                                Aplica en Recálculo
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Sin reglas configuradas -->
            <div class="card border-secondary mt-3" *ngIf="!versionDetail?.fees || versionDetail.fees.length === 0">
              <div class="card-body text-center"> 
                <i class="fas fa-list-ul text-muted mb-2" style="font-size: 2rem;"></i>
                <h6 class="text-muted">No se han configurado reglas de aplicación</h6>
                <small class="text-secondary">Esta versión no tiene reglas de aplicación definidas</small>
              </div>
            </div>
          </div>
        </div>

        <!-- SECCIÓN 3: CUENTA CONTABLE -->
        <div class="card mt-3 border-warning">
          <div class="card-header bg-warning bg-opacity-10">
            <div class="d-flex align-items-center">
              <i class="fas fa-university text-warning me-2"></i>
              <h5 class="mb-0 text-warning">Cuenta Contable SAP</h5>
            </div>
            <small class="text-secondary mt-1 d-block">
              Cuenta contable donde se registran los movimientos de esta penalidad
            </small>
          </div>
          <div class="card-body">
            <div class="row">
              <div class="col-12 mt-3">
                <div class="form-floating">
                  <input type="text" 
                         class="form-control readonly-input" 
                         [value]="getAccountDisplay(versionDetail.fee?.account_payment)"
                         readonly>
                  <label>
                    <i class="fas fa-landmark me-1"></i>
                    Cuenta Contable Vinculada
                  </label>
                  <div class="form-text">
                    <i class="fas fa-lightbulb text-warning me-1"></i>
                    Esta cuenta se usa para registrar contablemente los movimientos generados por esta penalidad en el sistema SAP
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- SECCIÓN 4: INFORMACIÓN DE AUDITORÍA -->
        <div class="card mt-3 border-info">
          <div class="card-header bg-info bg-opacity-10">
            <div class="d-flex align-items-center">
              <i class="fas fa-history text-info me-2"></i>
              <h5 class="mb-0 text-info">Información de Auditoría</h5>
            </div>
            <small class="text-secondary mt-1 d-block">
              Metadatos de creación y modificación de esta versión
            </small>
          </div>
          <div class="card-body">
            <div class="row">
              <div class="col-6">
                <div class="audit-card">
                  <div class="audit-header">
                    <i class="fas fa-plus-circle text-success me-2"></i>
                    <h6 class="mb-0">Creación</h6>
                  </div>
                  <div class="audit-content">
                    <div class="d-flex align-items-center mb-2">
                      <div class="user-avatar me-3">
                        {{ getUserInitials(versionDetail.user?.name || '') }}
                      </div>
                      <div>
                        <div class="user-name">{{ versionDetail.user?.name }}</div>
                        <div class="user-email">{{ versionDetail.user?.email }}</div>
                      </div>
                    </div>
                    <div class="audit-date">
                      <i class="fas fa-clock me-1"></i>
                      {{ formatDate(versionDetail.date) }}
                    </div>
                  </div>
                </div>
              </div>
              
              <div class="col-6" *ngIf="versionDetail.user_edit">
                <div class="audit-card">
                  <div class="audit-header">
                    <i class="fas fa-edit text-warning me-2"></i>
                    <h6 class="mb-0">Última Modificación</h6>
                  </div>
                  <div class="audit-content">
                    <div class="d-flex align-items-center mb-2">
                      <div class="user-avatar me-3">
                        {{ getUserInitials(versionDetail.user_edit?.name || '') }}
                      </div>
                      <div>
                        <div class="user-name">{{ versionDetail.user_edit?.name }}</div>
                        <div class="user-email">{{ versionDetail.user_edit?.email }}</div>
                      </div>
                    </div>
                    <div class="audit-date">
                      <i class="fas fa-clock me-1"></i>
                      {{ formatDate(versionDetail.edited_at || '') }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            
            <!-- Observación -->
            <div class="row mt-3" *ngIf="versionDetail.observation">
              <div class="col-12">
                <div class="observation-card">
                  <div class="observation-header">
                    <i class="fas fa-comment text-info me-2"></i>
                    <h6 class="mb-0">Observación</h6>
                  </div>
                  <div class="observation-content">
                    {{ versionDetail.observation }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Footer -->
    <div class="detail-footer">
      <div class="d-flex justify-content-between align-items-center">
        <div class="footer-info">
          <i class="fas fa-info-circle text-primary me-2"></i>
          <span class="text-muted">Configuración de versión en modo solo lectura</span>
        </div>
        <div class="footer-actions">
          <!-- Botón de timeline oculto temporalmente -->
          <!-- <button type="button" class="btn btn-outline-secondary me-2" (click)="backToTimeline()">
            <i class="fas fa-arrow-left me-2"></i>
            Volver al Timeline
          </button> -->
          <button type="button" class="btn btn-secondary" (click)="close()">
            <i class="fas fa-times me-2"></i>
            Cerrar
          </button>
        </div>
      </div>
    </div>
  </div>
</div> 